var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M11.858 7.002a5.47 5.47 0 0 0-4.032 1.93l-.807-.8a.305.305 0 0 0-.519.22v2.621c0 .171.134.306.306.306h2.62c.276 0 .41-.33.214-.52l-.947-.953A4.28 4.28 0 0 1 12 8.224c2.64 0 4.729 2.407 4.191 5.138-.33 1.693-1.717 3.043-3.409 3.343a4.275 4.275 0 0 1-4.918-3.153.62.62 0 0 0-.587-.44.61.61 0 0 0-.599.751A5.494 5.494 0 0 0 12 18a5.5 5.5 0 0 0 5.499-5.658c-.086-2.982-2.658-5.414-5.64-5.34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F44336",
    strokeLinecap: "round",
    d: "M12 9.75v3l2 1.5"
  })));
};
export default SvgCancel;